export default "__VITE_ASSET__lqDtKF9N__"